import { api } from "./api";

export const listarUsuarios = (termo) =>
  api.get(`/usuario/listar${termo ? `?termo=${encodeURIComponent(termo)}` : ""}`);
export const obterUsuario = (id) => api.get(`/usuario/${id}`);
export const salvarUsuario = (dto) => api.post("/usuario/salvar", dto);
export const resetarSenha = (id, novaSenha) =>
  api.post(`/usuario/resetar-senha/${id}`, { NovaSenha: novaSenha });
export const excluirUsuario = (id) => api.post(`/usuario/excluir/${id}`);
